export default {
  name: "valid-register",
  data() {
    return {
      iconStatus: "",
      iconColor: "",
      msgStatus: "",
      loading: false,
      id_affilliate: "",
    };
  },
  mounted() {
    this.validRegister();
  },
  watch: {
    dialog(val) {
      if (val) this.validRegister();
    }
  },
  computed: {
    dialog() {
      return this.$store.state.showDialogConfirmRegister;
    },
    logged() {
      return this.$store.state.logged.status;
    }
  },
  methods: {
    validRegister() {
      // Fecha dialog de registro
      this.$store.commit("showDialogRegister", false);

      const hash = this.$route.query.cod ?
        this.$route.query.cod :
        this.$route.params.cod;

      if (hash) {
        this.$handleURLState("open_confirm_register", "delete");
        this.$handleURLState("cod", "delete");
      } else {
        this.closeDialog();

        return;
      }

      const data = { hash, domain: this.$domain() };
      this.loading = true;

      this.$axios
        .post("player/register/confirmRegister", this.$formdata(data))
        .then((resp) => {
          this.iconStatus = "mdi-account-check";
          this.iconColor = "success";
          this.msgStatus = resp.data.messages;
          this.id_affilliate = resp.data.dados.id_affilliate;
          var data = resp.data.dados;

          return data;
        })
        .then((data) => {
          // Register Event Google Analytics
          this.$gtag.sign_up("main_register", data);
          // Register Event Active Campaign
          this.$activeCampaign("confirmRegister", data);
          // Register Account Zendesk
          this.$zendesk("confirmRegister", data);
          // Register Account RdStation
          this.$rdStation("confirmRegister", data);
        })
        .then(() => {
          // Register Tracker
          var domain = this.$domain();
          if (domain === "zep" && this.id_affilliate === "1437966") {
            var iframe = document.createElement("iframe");
            iframe.height = "1";
            iframe.width = "1";
            iframe.frameBorder = "0";
            iframe.style = "display:none;visibility:hidden";
            iframe.src = "https://linkado.vc/f?c=1306&e=l&g=330";
            var body = document.getElementsByTagName("body")[0];
            body.insertBefore(iframe, body.childNodes[0]);
          }
        })
        .catch((error) => {
          this.iconStatus = "mdi-alert-octagon";
          this.iconColor = "warning";
          this.msgStatus = error.response.data.messages.error;
        })
        .finally(() => (this.loading = false));
    },
    openDialogLogin() {
      this.closeDialog();
      this.$store.commit("setLoginDialog", true);
    },
    closeDialog() {
      this.$store.commit("showDialogConfirmRegister", false);
    },
  },
};
